module.exports = __webpack_public_path__ + "static/media/EAI-03.60994bdf.jpg";